var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeafBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 81,
    viewBox: "0 0 99 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7156 78.3297C43.7156 65.3445 45.0913 54.1257 47.7052 45.5917M47.7052 45.5917C52.9596 28.4572 63.2243 18.9735 77.4432 11.8641M47.7052 45.5917C44.155 34.9409 31.7424 27.6673 22.9244 25.4617M80.1726 30.8758C73.1741 37.8743 62.5765 38.6287 56.5056 32.5533C50.4302 26.4824 51.1846 15.8848 58.1831 8.88632C71.896 -4.82217 96.0823 6.17036 96.0823 6.17036C89.4877 12.765 87.1755 23.8729 80.1726 30.8758ZM14.6168 34.5904C20.1686 40.1466 28.5738 40.7412 33.3889 35.9262C38.2039 31.1111 37.6093 22.7059 32.0575 17.1541C21.1848 6.28141 2 14.9973 2 14.9973C7.23221 20.2296 9.06508 29.0387 14.6168 34.5904Z",
    stroke: "black",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafBlack);
export default __webpack_public_path__ + "static/media/leaf_black.f5898b486f21ea2f242cdd68b81cc599.svg";
export { ForwardRef as ReactComponent };